import { Box, Button, Typography } from "@mui/material";
import CustomDialog from "../shared/CustomDialog";
import { ReactComponent as Logo } from "../../assets/icons/logo-name.svg";

export function DownloadFromMarket(props) {
  const { open, setOpen } = props;

  return (
    <CustomDialog open={open}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: 264,
        }}
      >
        <Logo width={42} height={78} />
        <Typography align="center" sx={{ mt: 2 }} variant="h4" color="grey.2">
          دانلود اپلیکیشن بلوط
        </Typography>
        <Typography
          align="center"
          sx={{ mt: 1, flex: 1 }}
          variant="body2"
          color="grey.4"
        >
          برای تجربه کاربری بهتر، توصیه می‌کنیم اپلیکیشن بلوط را از بازار یا
          گوگل‌پلی دانلود کنید.{" "}
        </Typography>

        <Button
          onClick={() => {
            window.open("market://details?id=ir.baloot");
          }}
          sx={{
            mt: 2,
            color: "common.white",

            typography: "h5",
          }}
          variant="contained"
          size="small"
        >
          دانلود اپلیکیشن
        </Button>

        <Button
          onClick={() => {
            localStorage.setItem("add-to-home-screen-visited", "true");
            setOpen(false);
          }}
          sx={{
            mt: 2,
            // color: "grey.2",
            borderRadius: "12px",
            typography: "h3",
          }}
          variant="outlined"
          fullWidth
        >
          متوجه شدم
        </Button>
      </Box>
    </CustomDialog>
  );
}
